import Activity from "../../activity/model/Activity";
import DragWordToImgActivity from "../../ddTxtImg/model/DragWordToImgActivity";
import DropContainer from "./DropContainer";


class DragDropParagraphActivity extends DragWordToImgActivity {


    constructor() {

        super()
        this.activityType = this.DRAG_DROP_PARGRAPH
        this.dropItemContainer = new DropContainer()
        this.dropItemContainer.activityId = this.activityIndex
    }

    getAnsweredTrue = () => {


        let { dropItemList } = this.dropItemContainer


        for (let i = 0; i < dropItemList.length; i++) {
            let result = false
            //  console.log(dropItemList[i].dragList)
            for (let j = 0; j < dropItemList[i].dragList.length; j++) {
                if (dropItemList[i].solvedDragItem.dragIndex == dropItemList[i].dragList[j].dragIndex) {
                    result = true
                }

            }
            if (!result) {
                this.answeredTrue = false
            }

        }
    }

    resetActivity = () => {
        this.answeredTrue = true
        this.dropItemContainer.dropItemList = []
    }


    initFromJson = (obj) => {

        this.initPublicItemsFromJson(obj)
        this.dragContainerModel.initFromJson(obj.dragContainerModel)
        this.dropItemContainer.initFromJson(obj.dropItemContainer)
        this.dropItemContainer.activityId = this.activityIndex

    }


    getReportAsJson = () => {
        let obj = this.getPublicItemsAsJson();
        obj.dragContainerModel = this.dragContainerModel.getReportAsJson()
        obj.dropItemContainer = this.dropItemContainer.getReportAsJson()
        obj.answeredTrue = this.answeredTrue
        return obj
    }

    initReportFromJson = (obj) => {

        this.initPublicItemsFromJson(obj)
        this.dragContainerModel.initReportFromJson(obj.dragContainerModel)
        this.dropItemContainer.initReportFromJson(obj.dropItemContainer)
        this.dropItemContainer.activityId = this.activityIndex
        this.answeredTrue = obj.answeredTrue

    }
}

export default DragDropParagraphActivity 